
import { DatePicker, Form, Input, Select, SelectProps, Spin } from 'antd';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DATE_FORMAT_POST, PAGE_SIZE_DEFAULT, SYSTEM_TITLE } from 'utils/constants';

import { ActionType } from '@ant-design/pro-components';
import BoxContainer from 'base/ui/components/BoxContainer';
import dayjs from 'dayjs';
import usePartialState from 'hooks/usePartialState';
import { usePermission } from 'hooks/usePermission';
import { cloneDeep, debounce } from 'lodash';
import { observer } from 'mobx-react';
import moment from 'moment';
import { SearchModel } from 'pages/model';
import { useTranslation } from 'react-i18next';
import { HiSearch } from 'react-icons/hi';
import { getCompanyId, getRole, getUserName, getUserSession } from 'utils/localStorageHelper';
import { removeEmptyValue } from 'utils/searchHelper';
import { KanbanItems } from './Components/KanbanItem';

import CustomButton from 'base/ui/components/Button';
import CustomSelect from 'base/ui/components/CustomSelect';
import PageWrapper from 'pages/Components/PageWrapper';
import { CommonModel, createCommonServices } from 'services/Main/common_services';
import { IPurchaseOrderServices } from 'services/Main/purchaseOrder_services';
import { commonPresenter, commonStore, stockPresenter, stockStore } from 'stores/root_store';
import { getSearchParams, saveSearchParams } from 'utils/searchParamsHelper';

// màn hình Phê duyệt đơn hàng PP
const createReceiveSchedule3 = (services: IPurchaseOrderServices) => {
  return observer(() => {
    usePermission('INDEX');
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const commonServices = createCommonServices();

    const [searchParams] = useSearchParams();
    const viewUrl = searchParams.get('View');
    const navigate = useNavigate();

    const isCustomer = getUserSession().isCustomer;
    const pagetitle = 'Theo dõi giao/ nhận hàng v3';
    document.title = pagetitle + ' - ' + SYSTEM_TITLE;

    const tableRef = useRef<ActionType>();
    const [stateMaster, setStateMaster] = usePartialState({ loading: false, openDrawer: false });

    // NEW: view mode via dropdown (default Kanban)
    const [viewMode, setViewMode] = useState<'Kanban' | 'Danh sách'>('Kanban');


    const [formSearch] = Form.useForm()

    const [dataSearch, setDataSearch] = useState<SearchModel>({
      paging: {
        pageIndex: 1,
        pageSize: PAGE_SIZE_DEFAULT,
        orderBy: '',
        orderByDesc: '',
      },
      companyId: getCompanyId(),
      // salesOrg: getStoreId(),
      // documentDate: 'BEFORE_30_DAYS',
      // fromTime: moment().subtract(30, 'days'),
      searchDate: dayjs().format("YYYY-MM-DD"),
      toTime: moment(),
      screenCode: viewUrl || 'Schedule',
    });

    const showDrawer = () => setStateMaster({ openDrawer: true });
    const onCloseDrawer = () => setStateMaster({ openDrawer: false });

    const handleSearch = async (values: any) => {
      const dataResult = removeEmptyValue(cloneDeep(values));
      const dateFields = ['fromTime', 'toTime'];
      dateFields.forEach((field) => {
        if (dataResult[field]) dataResult[field] = dayjs(dataResult[field]).format(DATE_FORMAT_POST);
      });

      const tempDataSearch = {
        ...dataResult,
        paging: { ...dataSearch.paging, pageIndex: 1 },
        screenCode: viewUrl || 'Schedule',
        searchDate: dataResult.searchDate ? dayjs(dataResult.searchDate).format("YYYY-MM-DD") : undefined,
      };

      setDataSearch(tempDataSearch);

      // Nếu đang xem Danh sách thì reload table (Kanban thì component tự fetch theo props)
      setTimeout(() => {
        if (viewMode === 'Danh sách') tableRef.current?.reload();
      }, 0);

      onCloseDrawer();
    };


    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

    const initialValues = {
      ...dataSearch,
      fromTime: dataSearch.fromTime ? dayjs(dataSearch.fromTime) : undefined,
      toTime: dataSearch.toTime ? dayjs(dataSearch.toTime) : undefined,
      pageSize: 10,
    };

    useEffect(() => {
      setDataSearch((prev) => ({
        ...prev,
        screenCode: viewUrl || 'Schedule',
      }));
    }, [viewUrl]);

    const [pageSizeMain, setPageSizeMain] = useState(10)
    const onChangePageSize = (value: number) => {
      setPageSizeMain(value);
    }


    const [listVendor, setListVendor] = useState<any[]>([])
    // Dropdown kho nhận
    const [listStocks, setListStocks] = useState<SelectProps['options']>([])
    // Dropdown kho nhận
    const [listProducts, setListProducts] = useState<any[]>([])
    // sau khi render lần đầu thì set = true
    const [isReady, setIsReady] = useState(false)
    const [loadingSekeleton, setLoadingSekeleton] = useState(true)


    // Dropdown nhà cung cấp - ban đầu load 20 items đầu từ listVendorAll
    const getDropdownVendor = async (dataInit?: { label: string, value: string }) => {
      // const res = await commonServices.listVendorAll()
      let res: any = []
      await commonPresenter.getDropdownVendor(commonStore, { takeNumber: 20 })
      if (commonStore.commonRespone.isSuccess && commonStore.commonRespone.data.length) {
        res = commonStore.commonRespone
      }

      if (res && res?.isSuccess && res?.data) {
        // Chỉ lấy 20 items đầu
        const filtered = res.data?.map((item: any) => {
          return { label: item.value, value: item.key }
        })
        if (dataInit) {
          filtered.unshift(dataInit)
        }
        // loại bỏ trùng nhau (trường hợp dataInit đã tồn tại trong list)
        const uniqueVendors = Array.from(new Set(filtered.map((v: any) => v.value))).map((value: any) => {
          return filtered.find((v: any) => v.value === value)
        })
        console.log('uniqueVendors', uniqueVendors);

        setListVendor(uniqueVendors.slice(0, 10))
      }
    }
    // Khi search thì gọi listVendorAll và filter theo keyword
    const searchVendor = useCallback(debounce(async (keyword?: string) => {
      // const res = await commonServices.listVendorAll(keyword)
      let res: any = []
      await commonPresenter.getDropdownVendor(commonStore, { keyword: keyword || undefined, takeNumber: 20 })
      if (commonStore.commonRespone.isSuccess && commonStore.commonRespone.data.length) {
        res = commonStore.commonRespone
      }
      if (res && res?.isSuccess && res?.data) {
        if (keyword) {
          // Filter theo keyword trên client
          const filtered = res.data.filter((item: CommonModel) =>
            (item.value || '').toLowerCase().includes(keyword.toLowerCase())
          ).slice(0, 10) // Giới hạn 10 kết quả
          const mapped = filtered?.map((item: CommonModel) => {
            return { label: item.value, value: item.key }
          })
          setListVendor(mapped)

        } else {
          const filtered = res.data?.map((item: any) => {
            return { label: item.value, value: item.key }
          })
          // Nếu không có keyword thì chỉ lấy 20 items đầu
          setListVendor(filtered.slice(0, 10))
        }
      } else {
        // API trả về rỗng hoặc thất bại → clear danh sách
        setListVendor([])
      }
    }, 300), [])

    const searchProduct = useCallback(debounce(async (keyword?: string) => {
      const res = await commonServices.getDropdownProduct(keyword)
      if (res && res.isSuccess && res.data) {
        if (keyword) {
          // Filter theo keyword trên client
          const filtered = res.data.filter((item: CommonModel) =>
            (item.value || '').toLowerCase().includes(keyword.toLowerCase())
          )
          const mapped = filtered?.map((item: CommonModel) => {
            return { label: item.value, value: item.key }
          })
          setListProducts(mapped)
        } else {
          const filtered = res.data?.map(item => {
            return { label: item.value, value: item.key }
          })
          // Nếu không có keyword thì chỉ lấy 20 items đầu
          setListProducts(filtered)
        }
      }
    }, 300), [])

    // Danh sách kho
    const getDropdownStock = async (keyword?: string) => {
      await stockPresenter.searchAllStock(stockStore, keyword || '')
      if (stockStore.searchAllStockResponse.isSuccess) {
        const stocks = stockStore.searchAllStockResponse.data
        setListStocks(stocks.map(stock => ({ label: stock.value, value: stock.stockCode })))
      }
    }
    // Danh sách hàng hóa
    const getDropdownProduct = async () => {
      const res = await commonServices.getDropdownProduct()
      if (res && res.isSuccess && res.data) {
        const filtered = res.data?.map(item => {
          return { label: item.value, value: item.key }
        })
        setListProducts(filtered)
      }
    }

    useEffect(() => {
      (async () => {
        // Kiểm tra xem có saved search params không
        const savedParams = getSearchParams('receiveSchedule3');

        await Promise.allSettled([
          getDropdownVendor(savedParams?.vendorName && savedParams?.vendorNumber ? {
            label: savedParams?.vendorName,
            value: savedParams?.vendorNumber,
          } : undefined),
          getDropdownStock(),
          getDropdownProduct(),
        ])
        if (savedParams && !['NCC', 'NCC_CT'].includes(getRole())) {
          // Nếu có saved params, load lại trạng thái search trước đó
          let paramsToUse = { ...savedParams };

          // Mỗi lần vào màn hình luôn tìm theo ngày hiện tại,
          // nhưng vẫn giữ các bộ lọc đã lưu khác.
          const todayStr = dayjs().format('YYYY-MM-DD');
          paramsToUse = {
            ...paramsToUse,
            searchDate: todayStr,
          };
          saveSearchParams('receiveSchedule3', { ...paramsToUse });

          // Convert string date back to dayjs để hiển thị trong form
          const paramsWithDate = {
            ...paramsToUse,
            ...((['NCC', 'NCC_CT'].includes(getRole())) && { vendorNumber: getUserName() }),
            searchDate: dayjs(paramsToUse.searchDate),
          };

          // Set form values từ params đã cập nhật
          formSearch.setFieldsValue(paramsWithDate);

          handleSearch(paramsToUse);
        } else {
          // Nếu không có saved params, load data với giá trị mặc định
          const defaultParams = {
            searchDate: dayjs().format("YYYY-MM-DD"),
            ...((['NCC', 'NCC_CT'].includes(getRole())) && { vendorNumber: getUserName() }),
          };
          handleSearch(defaultParams);
          formSearch.setFieldsValue({
            ...defaultParams,
            searchDate: dayjs(defaultParams.searchDate),
          });

          // Lưu params mặc định
          saveSearchParams('receiveSchedule3', {
            searchDate: dayjs().format("YYYY-MM-DD"),
            ...((['NCC', 'NCC_CT'].includes(getRole())) && { vendorNumber: getUserName() }),
          });
        }

        setIsReady(true)
        setLoadingSekeleton(false)
      })()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      let timeoutId: NodeJS.Timer;
      if (isReady) {
        timeoutId = setInterval(() => {
          formSearch.submit()
        }, 60 * 1000)
      }
      return () => {
        clearInterval(timeoutId)
      }
    }, [isReady, formSearch]);



    return (
      <Spin spinning={stateMaster.loading} className="w-full">
        <PageWrapper
          breadcrumb={[{
            text: "Theo dõi giao/ nhận hàng (PP)"
          }]}
          extras={
            <CustomButton
              className='w-[100px]'
              onClick={() => {
                formSearch.resetFields();
                const defaultParams = {
                  searchDate: dayjs(),
                  ...((['NCC', 'NCC_CT'].includes(getRole())) && { vendorNumber: getUserName() }),
                };
                formSearch.setFieldsValue(defaultParams);
                handleSearch(defaultParams);
                saveSearchParams('receiveSchedule3', defaultParams)
              }}
            >
              {'Reset tìm kiếm'}
            </CustomButton>
          }
        />

        <BoxContainer className='!gap-0'>
          <div className='flex'>
            <SearchForm
              // className={isFullscreen ? '!hidden' : ''}
              layout='vertical'
              // column='col-5'
              colon={false}

              className='[&_.ant-form-item]:!mb-0'
              style={{ display: 'grid', gridTemplateColumns: 'max-content minmax(0, 1.15fr) repeat(3, minmax(0, 1fr))', gap: '16px' }}
              initialValues={{
                searchDate: dayjs(),
                ...((['NCC', 'NCC_CT'].includes(getRole())) && { vendorNumber: getUserName() }),
              }}
              form={formSearch}
              onFinish={(values) => {
                // Lưu search params vào localStorage
                saveSearchParams('receiveSchedule3', values)
                handleSearch(values)
                //  getReceiveSchedule(values)
              }}

            >
              <button type='submit' hidden></button>
              {/* Ngày giao hàng */}
              <SearchItem name={'searchDate'} label="Ngày giao hàng">
                <DatePicker className='w-full' allowClear={false} format={'DD/MM/YYYY'}
                  changeOnBlur
                  onSelect={(value) => {
                    formSearch.submit()
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      formSearch.submit()
                    }
                  }}
                />
              </SearchItem>
              {/* Nhà cung cấp */}
              <SearchItem name={'vendorNumber'} label="Nhà cung cấp">
                <Select
                  allowClear
                  options={listVendor}
                  // fieldNames={{ label: "value", value: 'key' }}
                  disabled={getRole() === 'NCC' || getRole() === 'NCC_CT'}
                  popupMatchSelectWidth={false}
                  showSearch
                  filterOption={false}
                  onSearch={searchVendor}
                  onSelect={(value, opt) => {
                    formSearch.submit()
                    formSearch.setFieldValue('vendorName', opt.label) // Set tên nhà cung cấp vào field ẩn
                  }}
                  // onFocus={() => {
                  //   searchVendor()
                  // }}
                  onClear={() => {
                    formSearch.submit()
                    formSearch.setFieldValue('vendorName', "") // Set tên nhà cung cấp vào field ẩn

                  }}
                  placeholder="Vui lòng chọn"
                />
              </SearchItem>

              {/* field ngầm, tên nhà cung cấp */}
              <SearchItem hidden name={'vendorName'} label=" ">
                <Input hidden />
              </SearchItem>

              {/* Kho */}
              <SearchItem name={'stockCodes'} label="Kho">
                <Select
                  allowClear
                  showSearch
                  mode='multiple'
                  options={listStocks}
                  filterOption={(input, option) => (option?.value + '' || '')?.toLowerCase()?.includes(input.toLowerCase())}
                  // onSelect={(value) => {
                  //   formSearch.submit()
                  // }}
                  onBlur={() => {
                    formSearch.submit()
                  }}
                  onDeselect={() => {
                    formSearch.submit()
                  }}
                  onClear={() => {
                    formSearch.submit()
                  }}
                  placeholder="Vui lòng chọn"
                />
              </SearchItem>
              {/* Hàng hóa */}
              <SearchItem name={'productCodes'} label="Hàng hóa">
                <Select
                  mode='multiple'
                  allowClear
                  options={listProducts}
                  disabled={getRole() === 'NCC' || getRole() === 'NCC_CT'}
                  filterOption={false}
                  popupMatchSelectWidth={false}
                  onSearch={searchProduct}
                  showSearch
                  onBlur={() => {
                    formSearch.submit()
                  }}
                  onDeselect={() => {
                    formSearch.submit()
                  }}
                  onClear={() => {
                    formSearch.submit()
                  }}
                  onFocus={() => {
                    // Khi focus thì load lại 20 items đầu
                    getDropdownProduct()
                  }}
                  placeholder="Vui lòng chọn"
                />
              </SearchItem>
              {/* Loại phiếu
              <SearchItem name={'type'} label="Loại phiếu">
                <Select
                  allowClear
                  placeholder="Vui lòng chọn"
                  onBlur={() => {
                    formSearch.submit()
                  }}
                  onSelect={(value) => {
                    formSearch.submit()
                  }}
                  onClear={() => {
                    formSearch.submit()
                  }}
                >
                  <Select.Option value="WasteMaterial">Chất thải/Phế liệu</Select.Option>
                  <Select.Option value="AVN_WF">Nguyên vật liệu</Select.Option>
                </Select>
              </SearchItem>
               */}

              {/* Số xe */}
              <SearchItem name={'licensePlate'} label="Số xe">
                <Input onBlur={() => {
                  formSearch.submit()
                }}
                  placeholder="Nhập số xe"
                />
              </SearchItem>
            </SearchForm>
            <div
              style={{
                display: viewMode === 'Danh sách' ? 'none' : 'flex'
              }}
              className='flex items-center gap-2 !w-[200px] justify-end pt-[19px]'>
              <div className='text-xs font-semibold'>Xem</div>
              <CustomSelect
                className='!w-[80px]'
                value={pageSizeMain}
                onChange={onChangePageSize}
                options={[
                  { label: '10', value: 10 },
                  { label: '20', value: 20 },
                  { label: '50', value: 50 },
                  { label: '100', value: 100 },
                ]}
                placeholder={t('Customize')}
              />
              <div className='text-xs font-semibold'>Mục</div>
            </div>
          </div>


          <KanbanItems
            pageSizeMain={pageSizeMain}
            dataSearch={dataSearch}
          />
        </BoxContainer>

        <SearchBox
          className="lg:!w-[50%]"
          footer={[
            <div key="footer" className="flex justify-end">
              <CustomButton
                type="primary"
                icon={<HiSearch />}
                onClick={() => {
                  form.submit();
                  onCloseDrawer();
                }}
              >
                {t('Search')}
              </CustomButton>
            </div>,
          ]}
          onClose={onCloseDrawer}
          open={stateMaster.openDrawer}
        >
          {/* <SearchForm column="col-2" className="md:w-[50%]" form={form} initialValues={initialValues} onFinish={handleSearch}>
            <SearchFormSO form={form} isCustomer={isCustomer} viewUrl={viewUrl || ''} />
          </SearchForm> */}
        </SearchBox>
      </Spin>
    );
  });
};

export default createReceiveSchedule3;
